import React, { useEffect } from "react";

import { Activity, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import Button from "../../Components/Button";
import PageHeader from "../../Components/PageHeader";
import CreateAssessmentTemplateContainer from "../../Container/CreateAssessmentTemplateContainer";
import { useAppDispatch, useAppSelector } from "../../Store/Hooks";
import {
  createAssessmentTemplate,
  clearError,
  clearCreateTemplateSuccess,
  CreateTemplateRequest,
} from "../../Store/Reducers/AssessmentSlice";

const CreateAssessmentTemplate: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isCreatingTemplate, createTemplateSuccess } = useAppSelector(
    state => state.assessment
  );

  useEffect(() => {
    if (createTemplateSuccess) {
      dispatch(clearCreateTemplateSuccess());
      navigate("/ops?tab=assessments");
    }
  }, [createTemplateSuccess, dispatch, navigate]);

  useEffect(() => {
    return () => {
      dispatch(clearError());
    };
  }, [dispatch]);

  const handleBack = () => {
    navigate("/ops?tab=assessments");
  };

  const handleSubmit = async (payload: CreateTemplateRequest) => {
    await dispatch(createAssessmentTemplate(payload)).unwrap();
  };

  return (
    <div className="create-assessment-template-page bg-white overflow-hidden mt-3">
      <PageHeader
        title={
          <div className="header-title-with-back">
            <Button variant="clear" onClick={handleBack} className="back-btn">
              <ArrowLeft size={15} color="#5F6368" />
            </Button>
            Create Assessment Template
          </div>
        }
        breadcrumb={[
          { title: "Artifacts Library" },
          { title: "Create Template" },
        ]}
        actions={[
          <Button
            key="lightning"
            className="lightning-container"
            variant="clear"
          >
            <Activity size={20} style={{ width: 14 }} />
          </Button>,
        ]}
      />
      <div className="w-full bg-white p-3 md:p-4">
        <div className="rounded-md bg-gray-100 p-4 md:p-4">
          <CreateAssessmentTemplateContainer
            onBack={handleBack}
            onSubmit={handleSubmit}
            isSubmitting={isCreatingTemplate}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateAssessmentTemplate;
